import request from '@/utils/request'

export default {
    exchange: function (query) {
        return request({
            url: 'credit/exchange',
            method: 'post',
            params: {
                traderId: query.traderId,
                goodsId: query.goodsId,
                goodsName: query.goodsName,
                goodsClass: query.goodsClass,
                phone: query.phone
            }
        });
    },
    getAddress: function () {
        return request({
            url: 'credit/getAddress',
            method: 'post',
            params: {}
        });
    },
    getLoginCode: function (phone, goodsClass) {
        return request({
            url: 'credit/getLoginCode',
            method: 'post',
            params: {
                phone: phone,
                goodsClass: goodsClass,
            }
        });
    },
    login: function (phone, code, goodsClass) {
        return request({
            url: 'credit/login',
            method: 'post',
            params: {
                phone: phone,
                code: code,
                goodsClass: goodsClass,
            }
        });
    },
    regist: function (phone, receiver, addr, goodsClass) {
        return request({
            url: 'credit/regist',
            method: 'post',
            params: {
                phone: phone,
                receiver: receiver,
                addr: addr,
                goodsClass: goodsClass,
            }
        });
    },
    getExchangeGoodsCode: function (phone, goodId, goodPoints, goodsClass, count) {
        return request({
            url: 'credit/getExchangeGoodsCode',
            method: 'post',
            params: {
                phone: phone,
                goodId: goodId,
                goodPoints: goodPoints,
                goodsClass: goodsClass,
                count: count,
            }
        });
    },
    exchangeGoods: function (query) {
        return request({
            url: 'credit/exchangeGoods',
            method: 'post',
            params: {
                traderId: query.traderId,
                phone: query.phone,
                code: query.exchangeCode,
                goodId: query.goodId,
                goodName: query.goodName,
                goodPoints: query.goodPoints,
                goodsClass: query.goodsClass,
                count: query.count,
            }
        });
    },
}